module.exports = __webpack_public_path__ + "static/torchafter-9b4e8e6a6160d4426804b07ed77c9f7a.jpg";